<template>
  <div>
    <!-- 切换大区 -->
    <div class="Dialog role" v-if="state.matches('zoneRole')">
      <div class="inner">
        <div class="pic-bg"></div>
        <div class="pic-birld"></div>
        <div class="pic-cloud"></div>

        <!--      <div class="icon-close"></div>-->
        <div class="title"><span>选择大区</span></div>

        <div class="inner-body">
          <div class="role-item">
            <span class="key">大区</span>
            <select class="select" v-model="state.context.selectedZone"
                    @change="send('CHANGE_ZONE',state.context.selectedZone)">
              <option disabled value="">请选择大区</option>
              <option v-for="(zone,index) in state.context.zoneList" :key="index" :value="zone">{{ zone.zone_name }}
              </option>
            </select>
          </div>
          <div class="role-item">
            <span class="key">角色</span>
            <select class="select" v-model="state.context.selectedRole">
              <option v-for="(role,index) in [state.context.selectedRole]" :key="index" :value="role">{{ role.name }}
              </option>
            </select>
          </div>
          <p class="description" style="margin-top:.2rem;width: 5rem;">
            <input type="checkbox" v-model="confirmZoneRole" style="vertical-align:middle;">
            <span style="vertical-align:middle;">
              温馨提示：本次活动需授权获取您的游戏角色与头像，选择后活动期间无法更改。
            </span>
          </p>
          <button class="btn-sure" v-if="state.matches('zoneRole.hasSelectedRole')"
                  @click="confirmRegister">确定
          </button>
          <button class="btn-sure" v-if="state.matches('zoneRole.register.failure')"
                  @click="send('RETRY')">确定
          </button>
          <button class="btn-sure" v-if="state.matches('zoneRole.fetchRole.failure')"
                  @click="send('RETOAST')">确定
          </button>
        </div>
      </div>
    </div>
    <Toast :toast-msg="tips" v-if="tips"></Toast>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api"
import Toast from "../../common/components/Toast.vue"
export default {
  name: "ZoneRole",
  props: ["state", "send"],
  components: {
    Toast
  },
  setup(props) {
    const confirmZoneRole = ref(false)
    const tips = ref("")
    const confirmRegister = () => {
      if (confirmZoneRole.value) {
        props.send("CONFIRM_REGISTER")
      } else {
        tips.value = "请确认温馨提示文案并勾选"
        setTimeout(() => {
          tips.value = ""
        }, 3000)
      }
    }
    return {
      tips,
      confirmZoneRole,
      confirmRegister
    }
  }
}
</script>

<style scoped>
</style>
